export const sessionIdFixture = "c698892f-be70-4f2e-879e-badf2bdaf0d1";

export const timingFixture = {
    duration_total_sec: 45,
    duration_coach_sec: 17,
    duration_student_sec: 28,
    duration_coach_pct: 38,
    duration_student_pct: 62,
}

export const feedbackFixture = {
    "feedback_summary": "The coach established a friendly tone and asked basic inventory questions about the portfolio, and provided brief encouragement. However the interaction lacked deeper exploratory questioning, clarification or co‑creation of next steps, and missed opportunities to elicit Charlotte's motivations, set concrete goals, or build accountability.",
    "strengths": [
        "Opened the conversation with a friendly, low‑pressure tone: \"hey how's it going today\"",
        "Asked inventory questions to surface portfolio contents: \"what kinds of stuff do you have in there right now\"",
        "Offered encouragement and normalizing language: \"great that sounds awesome\""
    ],
    "opportunities_for_growth": [
        "Use more open, exploratory questions to elicit learner reasoning and values rather than primarily inventory prompts",
        "Clarify and paraphrase the student's concerns to deepen understanding before offering suggestions",
        "Co‑create specific, timebound next steps (goals and checkpoints) and establish accountability for following up"
    ],
    "behavior_scores": [
        {
            "domain_code": "EC",
            "competency_code": "EC-2",
            "behavior_name": "Open Questions",
            "score": 3,
            "evidence": [
                "what kinds of stuff do you have in there right now",
                "that's great do you have any letters of recommendation from your professors?"
            ],
            "suggestion": "Shift from inventory questions to more open exploratory prompts (e.g., \"What would you like this portfolio to show about you?\"), and follow each with a probe to deepen reflection."
        },
        {
            "domain_code": "EC",
            "competency_code": "EC-3",
            "behavior_name": "Clarification",
            "score": 2,
            "evidence": [
                "I'm not entirely sure where to begin though.",
                "I do have a couple, but I'm not sure if they're strong enough"
            ],
            "suggestion": "Paraphrase and reflect the student's concern (e.g., \"So you're unsure which items best demonstrate your strengths — is that right?\") before offering suggestions to ensure shared understanding."
        },
        {
            "domain_code": "EC",
            "competency_code": "EC-3",
            "behavior_name": "Encouragement",
            "score": 4,
            "evidence": [
                "great that sounds awesome",
                "Thanks, I appreciate the encouragement."
            ],
            "suggestion": "Continue affirming and pair encouragement with specific observations (e.g., \"You already have clinical rotations and research — that's strong; let's identify the top 2 to highlight\")."
        },
        {
            "domain_code": "COCC",
            "competency_code": "COCC-2",
            "behavior_name": "Co-Creation",
            "score": 2,
            "evidence": [
                "uh we can take a look at those and assess whether or",
                "having at least something in there related to that will be good"
            ],
            "suggestion": "Move from brief suggestion to co‑creating a plan: ask the student to choose specific actions and timelines (e.g., \"Which letter could you request this week? Can we set a target date?\")."
        },
        {
            "domain_code": "MPA",
            "competency_code": "MPA-1",
            "behavior_name": "Progress Tracking",
            "score": 1,
            "evidence": [
                "I'll definitely look into getting more if needed.",
                "we can take a look at those and assess whether or"
            ],
            "suggestion": "Introduce concrete accountability by establishing a follow‑up checkpoint (e.g., \"Let's agree to review your letters in two weeks—does that work?\") and document the agreed timeline."
        }
    ],
    "mal": {
        "planning": {
            "gaps": [
                {
                    "gap": "Move from inventory questions to co-created next steps",
                    "rationale": "The coach surfaced portfolio contents and offered encouragement, but did not invite the learner to choose specific actions or timelines after uncertainty about letters of recommendation.",
                    "primary": true
                },
                {
                    "gap": "Clarify and paraphrase before advising",
                    "rationale": "The learner expressed uncertainty about where to begin and whether letters were strong enough; the coach did not consistently reflect that concern before suggesting next moves.",
                    "primary": false
                }
            ]
        },
        "learning": {
            "focus_skill": "Co-create one concrete next step",
            "practice_suggestion": "After inventorying portfolio items, ask the learner to pick one action and a target date (e.g., \"Which letter could you request this week, and by when?\")."
        },
        "assessing": {
            "success_criteria": "In the next session, at least one coach turn invites the learner to name a specific action and timeline, and the coach confirms that plan aloud."
        },
        "adjusting": {
            "next_session_commitment": "When the learner says they are unsure where to begin, first paraphrase the uncertainty, then ask them to choose one portfolio action and a follow-up date."
        }
    }
};

export const messagesFixture = {
    "d11cc945-f18f-4fdb-b50c-64a6aa093748": {
        "content": "hey how's it going today",
        "role": "USER",
        "generationStage": "FINAL",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"FINAL\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "d11cc945-f18f-4fdb-b50c-64a6aa093748",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971221028
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "hey how's it going today",
                        "contentId": "d11cc945-f18f-4fdb-b50c-64a6aa093748",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971221028
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "hey how's it going today",
                        "contentId": "d11cc945-f18f-4fdb-b50c-64a6aa093748",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971221028
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "d11cc945-f18f-4fdb-b50c-64a6aa093748",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971221028
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "d11cc945-f18f-4fdb-b50c-64a6aa093748",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971221028
            }
        ],
        "inputSource": "audio",
        "stopReason": "PARTIAL_TURN"
    },
    "704b50f5-b9e5-43cf-8f5a-75b8ca7d0404": {
        "content": "Hey, I'm doing alright, thanks for asking. How about you?",
        "role": "ASSISTANT",
        "generationStage": "SPECULATIVE",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"SPECULATIVE\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "704b50f5-b9e5-43cf-8f5a-75b8ca7d0404",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971221752
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "Hey, I'm doing alright, thanks for asking. How about you?",
                        "contentId": "704b50f5-b9e5-43cf-8f5a-75b8ca7d0404",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971221752
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "Hey, I'm doing alright, thanks for asking. How about you?",
                        "contentId": "704b50f5-b9e5-43cf-8f5a-75b8ca7d0404",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971221752
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "704b50f5-b9e5-43cf-8f5a-75b8ca7d0404",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971221753
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "704b50f5-b9e5-43cf-8f5a-75b8ca7d0404",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971221753
            }
        ],
        "inputSource": "audio",
        "stopReason": "PARTIAL_TURN"
    },
    "ee160cff-a089-4e29-8758-dfb13c289bfd": {
        "content": "Hey, I'm doing alright, thanks for asking. How about you?",
        "role": "ASSISTANT",
        "generationStage": "FINAL",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"FINAL\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "ee160cff-a089-4e29-8758-dfb13c289bfd",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971225432
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "Hey, I'm doing alright, thanks for asking. How about you?",
                        "contentId": "ee160cff-a089-4e29-8758-dfb13c289bfd",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971225433
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "Hey, I'm doing alright, thanks for asking. How about you?",
                        "contentId": "ee160cff-a089-4e29-8758-dfb13c289bfd",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971225433
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "ee160cff-a089-4e29-8758-dfb13c289bfd",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "END_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971225433
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "ee160cff-a089-4e29-8758-dfb13c289bfd",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "END_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971225433
            }
        ],
        "inputSource": "audio",
        "stopReason": "END_TURN"
    },
    "5472f8f9-968e-4016-a938-65ee3ebc387e": {
        "content": "good let's talk about your portfolio",
        "role": "USER",
        "generationStage": "FINAL",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"FINAL\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "5472f8f9-968e-4016-a938-65ee3ebc387e",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971228074
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "good let's talk about your portfolio",
                        "contentId": "5472f8f9-968e-4016-a938-65ee3ebc387e",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971228074
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "5472f8f9-968e-4016-a938-65ee3ebc387e",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971228074
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "good let's talk about your portfolio",
                        "contentId": "5472f8f9-968e-4016-a938-65ee3ebc387e",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971228074
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "5472f8f9-968e-4016-a938-65ee3ebc387e",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971228074
            }
        ],
        "inputSource": "audio",
        "stopReason": "PARTIAL_TURN"
    },
    "f29e22fc-2247-4cab-ab05-9386f215d891": {
        "content": "Sure, I guess we can start there. I'm not entirely sure where to begin though.",
        "role": "ASSISTANT",
        "generationStage": "SPECULATIVE",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"SPECULATIVE\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "f29e22fc-2247-4cab-ab05-9386f215d891",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971228472
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "Sure, I guess we can start there. I'm not entirely sure where to begin though.",
                        "contentId": "f29e22fc-2247-4cab-ab05-9386f215d891",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971228477
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "Sure, I guess we can start there. I'm not entirely sure where to begin though.",
                        "contentId": "f29e22fc-2247-4cab-ab05-9386f215d891",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971228477
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "f29e22fc-2247-4cab-ab05-9386f215d891",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971228477
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "f29e22fc-2247-4cab-ab05-9386f215d891",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971228477
            }
        ],
        "inputSource": "audio",
        "stopReason": "PARTIAL_TURN"
    },
    "a799503a-a8ec-478c-a82d-2bf415fa0f06": {
        "content": "Sure, I guess we can start there. I'm not entirely sure where to begin though.",
        "role": "ASSISTANT",
        "generationStage": "FINAL",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"FINAL\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "a799503a-a8ec-478c-a82d-2bf415fa0f06",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971234865
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "Sure, I guess we can start there. I'm not entirely sure where to begin though.",
                        "contentId": "a799503a-a8ec-478c-a82d-2bf415fa0f06",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971234865
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "Sure, I guess we can start there. I'm not entirely sure where to begin though.",
                        "contentId": "a799503a-a8ec-478c-a82d-2bf415fa0f06",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971234865
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "a799503a-a8ec-478c-a82d-2bf415fa0f06",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "END_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971234867
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "a799503a-a8ec-478c-a82d-2bf415fa0f06",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "END_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971234867
            }
        ],
        "inputSource": "audio",
        "stopReason": "END_TURN"
    },
    "750d1a9b-f7c9-43f6-958f-4e5ff83011a2": {
        "content": "what kinds of stuff do you have in there right now",
        "role": "USER",
        "generationStage": "FINAL",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"FINAL\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "750d1a9b-f7c9-43f6-958f-4e5ff83011a2",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971238092
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "what kinds of stuff do you have in there right now",
                        "contentId": "750d1a9b-f7c9-43f6-958f-4e5ff83011a2",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971238093
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "what kinds of stuff do you have in there right now",
                        "contentId": "750d1a9b-f7c9-43f6-958f-4e5ff83011a2",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971238093
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "750d1a9b-f7c9-43f6-958f-4e5ff83011a2",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971238093
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "750d1a9b-f7c9-43f6-958f-4e5ff83011a2",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971238093
            }
        ],
        "inputSource": "audio",
        "stopReason": "PARTIAL_TURN"
    },
    "4bbe6fea-e179-4003-9599-153905e32275": {
        "content": "Well, I have my clinical rotations documented, some research projects, and a few personal statements.",
        "role": "ASSISTANT",
        "generationStage": "SPECULATIVE",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"SPECULATIVE\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "4bbe6fea-e179-4003-9599-153905e32275",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971238568
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "Well, I have my clinical rotations documented, some research projects, and a few personal statements.",
                        "contentId": "4bbe6fea-e179-4003-9599-153905e32275",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971238569
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "Well, I have my clinical rotations documented, some research projects, and a few personal statements.",
                        "contentId": "4bbe6fea-e179-4003-9599-153905e32275",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971238569
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "4bbe6fea-e179-4003-9599-153905e32275",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971238569
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "4bbe6fea-e179-4003-9599-153905e32275",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971238569
            }
        ],
        "inputSource": "audio",
        "stopReason": "PARTIAL_TURN"
    },
    "14016c92-2cd4-49fc-b823-4b07ad1a3371": {
        "content": " I think that's about it for now.",
        "role": "ASSISTANT",
        "generationStage": "SPECULATIVE",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"SPECULATIVE\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "14016c92-2cd4-49fc-b823-4b07ad1a3371",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971241591
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": " I think that's about it for now.",
                        "contentId": "14016c92-2cd4-49fc-b823-4b07ad1a3371",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971241591
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "14016c92-2cd4-49fc-b823-4b07ad1a3371",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971241591
            }
        ],
        "inputSource": "audio",
        "stopReason": "PARTIAL_TURN"
    },
    "dd033550-fbf5-4cc6-a3c8-9ad8c6b1e3e5": {
        "content": "Well, I have my clinical rotations documented, some research projects, and a few personal statements.",
        "role": "ASSISTANT",
        "generationStage": "FINAL",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"FINAL\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "dd033550-fbf5-4cc6-a3c8-9ad8c6b1e3e5",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971246443
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "Well, I have my clinical rotations documented, some research projects, and a few personal statements.",
                        "contentId": "dd033550-fbf5-4cc6-a3c8-9ad8c6b1e3e5",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971246447
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "Well, I have my clinical rotations documented, some research projects, and a few personal statements.",
                        "contentId": "dd033550-fbf5-4cc6-a3c8-9ad8c6b1e3e5",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971246447
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "dd033550-fbf5-4cc6-a3c8-9ad8c6b1e3e5",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "END_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971246447
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "dd033550-fbf5-4cc6-a3c8-9ad8c6b1e3e5",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "END_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971246447
            }
        ],
        "inputSource": "audio",
        "stopReason": "END_TURN"
    },
    "2f8be41f-d96b-46bb-8b22-28a437e18fb8": {
        "content": " I think that's about it for now.",
        "role": "ASSISTANT",
        "generationStage": "FINAL",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"FINAL\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "2f8be41f-d96b-46bb-8b22-28a437e18fb8",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971248285
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": " I think that's about it for now.",
                        "contentId": "2f8be41f-d96b-46bb-8b22-28a437e18fb8",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971248285
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": " I think that's about it for now.",
                        "contentId": "2f8be41f-d96b-46bb-8b22-28a437e18fb8",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971248285
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "2f8be41f-d96b-46bb-8b22-28a437e18fb8",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971248285
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "2f8be41f-d96b-46bb-8b22-28a437e18fb8",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971248285
            }
        ],
        "inputSource": "audio",
        "stopReason": "PARTIAL_TURN"
    },
    "f00f4509-bb7a-4ba6-9523-5b6a894fe39d": {
        "content": "that's great do you have any letters of recommendation from your professors?",
        "role": "USER",
        "generationStage": "FINAL",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"FINAL\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "f00f4509-bb7a-4ba6-9523-5b6a894fe39d",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971252306
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "that's great do you have any letters of recommendation from your professors?",
                        "contentId": "f00f4509-bb7a-4ba6-9523-5b6a894fe39d",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971252306
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "that's great do you have any letters of recommendation from your professors?",
                        "contentId": "f00f4509-bb7a-4ba6-9523-5b6a894fe39d",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971252306
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "f00f4509-bb7a-4ba6-9523-5b6a894fe39d",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971252307
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "f00f4509-bb7a-4ba6-9523-5b6a894fe39d",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971252307
            }
        ],
        "inputSource": "audio",
        "stopReason": "PARTIAL_TURN"
    },
    "30509b3b-e12b-43bb-8846-ce2cae16334f": {
        "content": "I do have a couple, but I'm not sure if they're strong enough or if I need more.",
        "role": "ASSISTANT",
        "generationStage": "SPECULATIVE",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"SPECULATIVE\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "30509b3b-e12b-43bb-8846-ce2cae16334f",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971252926
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "I do have a couple, but I'm not sure if they're strong enough or if I need more.",
                        "contentId": "30509b3b-e12b-43bb-8846-ce2cae16334f",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971252926
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "30509b3b-e12b-43bb-8846-ce2cae16334f",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971252926
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "I do have a couple, but I'm not sure if they're strong enough or if I need more.",
                        "contentId": "30509b3b-e12b-43bb-8846-ce2cae16334f",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971252926
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "30509b3b-e12b-43bb-8846-ce2cae16334f",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971252926
            }
        ],
        "inputSource": "audio",
        "stopReason": "PARTIAL_TURN"
    },
    "47d9c7bc-2ae9-4255-bf2b-36d0d01efd24": {
        "content": "I do have a couple, but I'm not sure if they're strong enough or if I need more.",
        "role": "ASSISTANT",
        "generationStage": "FINAL",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"FINAL\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "47d9c7bc-2ae9-4255-bf2b-36d0d01efd24",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971259066
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "I do have a couple, but I'm not sure if they're strong enough or if I need more.",
                        "contentId": "47d9c7bc-2ae9-4255-bf2b-36d0d01efd24",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971259066
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "47d9c7bc-2ae9-4255-bf2b-36d0d01efd24",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "END_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971259066
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "I do have a couple, but I'm not sure if they're strong enough or if I need more.",
                        "contentId": "47d9c7bc-2ae9-4255-bf2b-36d0d01efd24",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971259066
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "47d9c7bc-2ae9-4255-bf2b-36d0d01efd24",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "END_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971259066
            }
        ],
        "inputSource": "audio",
        "stopReason": "END_TURN"
    },
    "e2e031b4-6087-40ad-8745-630f833e6dbf": {
        "content": "uh we can take a look at those and assess whether or",
        "role": "USER",
        "generationStage": "FINAL",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"FINAL\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "e2e031b4-6087-40ad-8745-630f833e6dbf",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971264089
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "uh we can take a look at those and assess whether or",
                        "contentId": "e2e031b4-6087-40ad-8745-630f833e6dbf",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971264089
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "uh we can take a look at those and assess whether or",
                        "contentId": "e2e031b4-6087-40ad-8745-630f833e6dbf",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971264089
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "e2e031b4-6087-40ad-8745-630f833e6dbf",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971264089
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "e2e031b4-6087-40ad-8745-630f833e6dbf",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971264089
            }
        ],
        "inputSource": "audio",
        "stopReason": "PARTIAL_TURN"
    },
    "86d18a8f-94f9-4361-8aa1-7394ea10d295": {
        "content": "not they are appropriate to include but i think",
        "role": "USER",
        "generationStage": "FINAL",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"FINAL\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "86d18a8f-94f9-4361-8aa1-7394ea10d295",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971268152
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "not they are appropriate to include but i think",
                        "contentId": "86d18a8f-94f9-4361-8aa1-7394ea10d295",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971268152
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "not they are appropriate to include but i think",
                        "contentId": "86d18a8f-94f9-4361-8aa1-7394ea10d295",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971268152
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "86d18a8f-94f9-4361-8aa1-7394ea10d295",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971268153
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "86d18a8f-94f9-4361-8aa1-7394ea10d295",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971268153
            }
        ],
        "inputSource": "audio",
        "stopReason": "PARTIAL_TURN"
    },
    "d739ef76-e6cd-4ba9-af3e-0e80d37c6ba5": {
        "content": "having at least something in there related to that will be good",
        "role": "USER",
        "generationStage": "FINAL",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"FINAL\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "d739ef76-e6cd-4ba9-af3e-0e80d37c6ba5",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971272007
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "having at least something in there related to that will be good",
                        "contentId": "d739ef76-e6cd-4ba9-af3e-0e80d37c6ba5",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971272007
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "having at least something in there related to that will be good",
                        "contentId": "d739ef76-e6cd-4ba9-af3e-0e80d37c6ba5",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971272007
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "d739ef76-e6cd-4ba9-af3e-0e80d37c6ba5",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971272008
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "d739ef76-e6cd-4ba9-af3e-0e80d37c6ba5",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971272008
            }
        ],
        "inputSource": "audio",
        "stopReason": "PARTIAL_TURN"
    },
    "be8df50e-3f51-435b-887e-2d1cafd90414": {
        "content": "I see what you mean. I'll definitely look into getting more if needed.",
        "role": "ASSISTANT",
        "generationStage": "SPECULATIVE",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"SPECULATIVE\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "be8df50e-3f51-435b-887e-2d1cafd90414",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971272425
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "I see what you mean. I'll definitely look into getting more if needed.",
                        "contentId": "be8df50e-3f51-435b-887e-2d1cafd90414",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971272425
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "be8df50e-3f51-435b-887e-2d1cafd90414",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971272425
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "I see what you mean. I'll definitely look into getting more if needed.",
                        "contentId": "be8df50e-3f51-435b-887e-2d1cafd90414",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971272425
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "be8df50e-3f51-435b-887e-2d1cafd90414",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971272425
            }
        ],
        "inputSource": "audio",
        "stopReason": "PARTIAL_TURN"
    },
    "5d8e62da-a37b-4417-a46c-fb69d567f5c9": {
        "content": "I see what you mean. I'll definitely look into getting more if needed.",
        "role": "ASSISTANT",
        "generationStage": "FINAL",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"FINAL\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "5d8e62da-a37b-4417-a46c-fb69d567f5c9",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971276969
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "I see what you mean. I'll definitely look into getting more if needed.",
                        "contentId": "5d8e62da-a37b-4417-a46c-fb69d567f5c9",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971276969
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "I see what you mean. I'll definitely look into getting more if needed.",
                        "contentId": "5d8e62da-a37b-4417-a46c-fb69d567f5c9",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971276969
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "5d8e62da-a37b-4417-a46c-fb69d567f5c9",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "END_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971276970
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "5d8e62da-a37b-4417-a46c-fb69d567f5c9",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "END_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971276970
            }
        ],
        "inputSource": "audio",
        "stopReason": "END_TURN"
    },
    "e3f9598d-2035-4b4b-9294-700f2739ce8d": {
        "content": "great that sounds awesome",
        "role": "USER",
        "generationStage": "FINAL",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"FINAL\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "e3f9598d-2035-4b4b-9294-700f2739ce8d",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971280042
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "great that sounds awesome",
                        "contentId": "e3f9598d-2035-4b4b-9294-700f2739ce8d",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971280042
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "great that sounds awesome",
                        "contentId": "e3f9598d-2035-4b4b-9294-700f2739ce8d",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "USER",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971280042
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "e3f9598d-2035-4b4b-9294-700f2739ce8d",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971280043
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "e3f9598d-2035-4b4b-9294-700f2739ce8d",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971280043
            }
        ],
        "inputSource": "audio",
        "stopReason": "PARTIAL_TURN"
    },
    "a36b4f45-aea1-48fa-ba16-787686feac68": {
        "content": "Thanks, I appreciate the encouragement.",
        "role": "ASSISTANT",
        "generationStage": "SPECULATIVE",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"SPECULATIVE\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "a36b4f45-aea1-48fa-ba16-787686feac68",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971280419
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "Thanks, I appreciate the encouragement.",
                        "contentId": "a36b4f45-aea1-48fa-ba16-787686feac68",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971280419
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "a36b4f45-aea1-48fa-ba16-787686feac68",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971280419
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "a36b4f45-aea1-48fa-ba16-787686feac68",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "PARTIAL_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971280419
            }
        ],
        "inputSource": "audio",
        "stopReason": "PARTIAL_TURN"
    },
    "91460412-35df-4740-b04c-2e1918df80ce": {
        "content": "Thanks, I appreciate the encouragement.",
        "role": "ASSISTANT",
        "generationStage": "FINAL",
        "raw": [
            {
                "event": {
                    "contentStart": {
                        "additionalModelFields": "{\"generationStage\":\"FINAL\"}",
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "91460412-35df-4740-b04c-2e1918df80ce",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "textOutputConfiguration": {
                            "mediaType": "text/plain"
                        },
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971283035
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "Thanks, I appreciate the encouragement.",
                        "contentId": "91460412-35df-4740-b04c-2e1918df80ce",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971283035
            },
            {
                "event": {
                    "textOutput": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "content": "Thanks, I appreciate the encouragement.",
                        "contentId": "91460412-35df-4740-b04c-2e1918df80ce",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "role": "ASSISTANT",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0"
                    }
                },
                "timestamp": 1767971283035
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "91460412-35df-4740-b04c-2e1918df80ce",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "END_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971283035
            },
            {
                "event": {
                    "contentEnd": {
                        "completionId": "bb196ea7-43ee-4502-8fc0-c1f15beefc83",
                        "contentId": "91460412-35df-4740-b04c-2e1918df80ce",
                        "promptName": "956df6c4-59c5-47d0-9ecb-32ad2f933f96",
                        "sessionId": "cf9b7396-f802-49f9-9d4d-1b329e073df0",
                        "stopReason": "END_TURN",
                        "type": "TEXT"
                    }
                },
                "timestamp": 1767971283035
            }
        ],
        "inputSource": "audio",
        "stopReason": "END_TURN"
    }
};